import { Form, Modal, message, Table, Tag, Descriptions, Tooltip } from "antd";
import { useEffect, useState } from "react";
import Presets from "@extensions/presets";
import { serverFetch } from "@server";
import { fmtDateTimeFull } from "@extensions/utils";
import "./log-monitor-item.css";

const LogMonitorItem = ({ id, onClose }) => {
  const [item, setItem] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (id) {
      setLoading(true);
      serverFetch(`LogUser/${id}`, { method: 'GET' })
        .then(data => {
          setLoading(false);
          setItem(data);
        })
        .catch((e) => {
          setLoading(false);
          message.error(e.UserMessage || "Ошибка загрузки данных");
          console.log(e);
        });
    }
  }, [id]);

  const toDisplayString = (value) => {
    if (value === null || value === undefined) return '';
    if (typeof value === 'string') return value;
    try {
      return JSON.stringify(value);
    } catch {
      return String(value);
    }
  };

  const renderClippedCell = (text, className) => {
    const display = text !== undefined && text !== null && text !== '' ? toDisplayString(text) : '(пусто)';
    return (
      <Tooltip
        title={display}
        placement="topLeft"
        overlayInnerStyle={{ maxWidth: 560, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
      >
        <div className={`log-monitor-cell-clipped ${className || ''}`}>{display}</div>
      </Tooltip>
    );
  };

  const changes = item?.previousLogChanges;
  const changesColumns = [
    { 
      title: 'Поле', 
      dataIndex: 'fieldName', 
      align: 'left',
      width: 160,
      render: (text) => {
        const display = text || '-';
        return (
          <Tooltip
            title={display}
            placement="topLeft"
            overlayInnerStyle={{ maxWidth: 560, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
          >
            <div className="log-monitor-cell-clipped log-monitor-change-field">
              <strong>{display}</strong>
            </div>
          </Tooltip>
        );
      }
    },
    { 
      title: 'Было', 
      dataIndex: 'oldValue', 
      align: 'left',
      width: 390,
      render: (text) => renderClippedCell(text, 'log-monitor-change-old')
    },
    { 
      title: 'Стало', 
      dataIndex: 'newValue', 
      align: 'left',
      width: 390,
      render: (text) => renderClippedCell(text, 'log-monitor-change-new')
    },
  ];

  return (
    <Modal 
      {...Presets.modalInfo} 
      title="Изменения в действии" 
      width={1000} 
      onCancel={() => onClose()}
    >
      <Form colon={false} disabled={loading} readOnly={true}>
        {item && (
          <>
            <Descriptions column={2} bordered size="small" style={{ marginBottom: 16 }}>
              <Descriptions.Item label="ID">{item.id}</Descriptions.Item>
              <Descriptions.Item label="Дата">{fmtDateTimeFull(item.createdOn)}</Descriptions.Item>
              <Descriptions.Item label="Пользователь">{item.userName || '-'}</Descriptions.Item>
              <Descriptions.Item label="Email">{item.userEmail || '-'}</Descriptions.Item>
              <Descriptions.Item label="Комментарий" span={2}>{item.comment || '-'}</Descriptions.Item>
            </Descriptions>

            {changes && (
              <div style={{ marginTop: 16 }}>
                <Descriptions column={1} bordered size="small" style={{ marginBottom: 16 }}>
                  {changes.leftLogId && (
                    <Descriptions.Item label="Предыдущий лог ID">
                      {changes.leftLogId}
                    </Descriptions.Item>
                  )}
                  <Descriptions.Item label="Текущий лог ID">
                    {changes.rightLogId}
                  </Descriptions.Item>
                  {changes.leftCreatedOn && (
                    <Descriptions.Item label="Дата предыдущего лога">
                      {fmtDateTimeFull(changes.leftCreatedOn)}
                    </Descriptions.Item>
                  )}
                  <Descriptions.Item label="Дата текущего лога">
                    {fmtDateTimeFull(changes.rightCreatedOn)}
                  </Descriptions.Item>
                  <Descriptions.Item label="Всего изменений">
                    <Tag color={(changes.totalChanges || 0) > 0 ? "orange" : "default"}>
                      {changes.totalChanges || 0}
                    </Tag>
                  </Descriptions.Item>
                  <Descriptions.Item label="Первое изменение">
                    <Tag color={changes.isFirstChange ? "blue" : "default"}>
                      {changes.isFirstChange ? "Да" : "Нет"}
                    </Tag>
                  </Descriptions.Item>
                  {changes.message && (
                    <Descriptions.Item label="Сообщение">
                      {changes.message}
                    </Descriptions.Item>
                  )}
                </Descriptions>

                {changes.changes && changes.changes.length > 0 ? (
                  <div>
                    <h4 style={{ marginBottom: 8 }}>Список изменений:</h4>
                    <div className="log-monitor-changes-wrapper">
                      <Table
                        dataSource={changes.changes}
                        columns={changesColumns}
                        pagination={false}
                        rowKey={(record, index) => index}
                        size="small"
                        bordered
                        className="log-monitor-changes-table"
                      />
                    </div>
                  </div>
                ) : (
                  <div style={{ padding: 16, textAlign: 'center', color: '#999' }}>
                    Изменений не обнаружено
                  </div>
                )}
              </div>
            )}

            {!changes && (
              <div style={{ padding: 16, textAlign: 'center', color: '#999' }}>
                Информация об изменениях недоступна
              </div>
            )}
          </>
        )}
      </Form>
    </Modal>
  );
};

export default LogMonitorItem;
